import MUITableBody, { TableBodyProps } from "@material-ui/core/TableBody";

const TableBody = (props: TableBodyProps) => <MUITableBody {...props} />;

export default TableBody;
